import { ToastContainer } from "react-toastify"
import { AffiliateContent } from "../components/affiliate/AffiliateContent"
import { AffiliateInfoContent } from "../components/affiliate/AffiliateInfoContent"
import AffiliateSignUp from "../components/affiliate/AffiliateSignUp"
import { Footer } from "../components/Footer"
import { Header } from "../components/Header"

export const AffiliatePage = () => {
  return (
    <>
      <ToastContainer autoClose={6000} />
      <div className="main__bg">
        <video autoPlay loop muted playsInline poster="img/bg.jpg" className="fullscreen-bg__video">
          <source src="/img/video_bg.mp4" type="video/mp4" />
        </video>
        <div className="main-box">
          <Header />
          <AffiliateInfoContent />
        </div>
      </div>

      <AffiliateContent />
      {AffiliateSignUp()}

      <Footer isDark={true} />
    </>
  )
}
